export const downloadPlainTextFile = ({
  content,
  fileName,
}: {
  content: string
  fileName: string
}) => {
  const link = document.createElement('a')
  link.download = fileName
  link.href = `data:text/plain;charset=utf-8,${encodeURIComponent(content)}`

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadFromUrl = ({
  url,
  fileName,
}: {
  url: string
  fileName: string
}) => {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.style.display = 'none'

  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

const exports = {
  downloadFromUrl,
  downloadPlainTextFile,
}

export default exports
